import React, { useEffect, useState } from "react";
import dashboard from "../../../assets/dashboardIcon.png";
import team from "../../../assets/teamImage.png";
import update from "../../../assets/updateImage.png";
import jobPost from "../../../assets/jobPost.png";
import community from "../../../assets/commuityImage.png";
import subscription from "../../../assets/subscriptionImage.png";
import setting from "../../../assets/settings.png";
import conversion from "../../../assets/conversionImage.png";
import helpDesk from "../../../assets/helpDesk.png";
import logout from "../../../assets/logout.png";
import Resumes from "../../../assets/resumeIcons.png"
import savedSearch from "../../../assets/icons8-save-search-24.png"
import "../../../styles/businessDashboardStyle.css";
import { useDispatch, useSelector } from "react-redux";
import { logoutApi } from "../../services/operations/authAPI";
import { useNavigate, useLocation } from "react-router-dom";
import { NavLink } from "react-router-dom";
import Loader from "../../Loader/Loader";

const iconMap = {
  "Dashboard": dashboard,
  "My Team": team,
  "Update": update,
  "Job Posting": jobPost,
  "Conversion": conversion,
  "Community": community,
  "Subscription": subscription,
  "Settings": setting,
  "Help Desk": helpDesk,
  "Resumes":Resumes,
  "Saved Searches":savedSearch
};

const SideBar = ({ isOpen }) => {
  const token = useSelector((state) => state.auth.token);
  const loading = useSelector((state) => state.auth.loading);
  const user = useSelector((state) => state.profile.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [menus, setMenus] = useState([]);


//   useEffect(() => {
//   if (user?.roles) {

//     const allPermissions = user.roles.flatMap(role => role.permissions || []);

//     const uniquePermissions = allPermissions.filter(
//       (perm, index, self) =>
//         index === self.findIndex(p => p.path === perm.path)
//     );
//     const sortedPermissions = uniquePermissions.sort((a, b) => {
//       if (a.displayName === "Dashboard") return -1;
//       if (b.displayName === "Dashboard") return 1;
//       return 0;
//     });

//     setMenus(sortedPermissions);
//   }
// }, [user]);

useEffect(() => {
  if (user?.roles) {
    const allPermissions = user.roles.flatMap(role => role.permissions || []);

    const uniquePermissions = allPermissions.filter(
      (perm, index, self) =>
        index === self.findIndex(p => p.path === perm.path)
    );
    const hiddenMenus = ["Community", "Conversion", "Help Desk","Settings"];
    const visiblePermissions = uniquePermissions.filter(
      (perm) => !hiddenMenus.includes(perm.displayName)
    );

    const sortedPermissions = visiblePermissions.sort((a, b) => {
      return 0;
    });

    setMenus(sortedPermissions);
  }
}, [user]);

  const handleLogout = async () => {
    await dispatch(logoutApi(token, navigate));
  };

  return (
    <nav className={`sidebar ${isOpen ? "show" : ""}`}>
      {loading && <Loader />}

      <ul className="sidebar-menu top-items">
        {menus.map((menu, index) => (
          <li key={index}
           className={location.pathname === menu.path ? "active-menu" : ""}
          >
            <NavLink
              to={menu.path}
              className={({ isActive }) => (isActive ? "active-menu" : "")}
            >
              <img
                src={iconMap[menu.displayName]}
                alt={menu.displayName}
                className="sidebar-icon"
              />
              {isOpen && <span className="menu-item-name">{menu.displayName}</span>}
            </NavLink>
          </li>
        ))}
      </ul>


<ul className="sidebar-menu bottom-items">
        <li>
          <a onClick={handleLogout}>
            <img
              src={logout}
              alt="Logout"
              className="sidebar-icon"
             // style={{ width: "40px", height: "40px" }}
            />
            {isOpen && <span className="menu-item-name">Logout</span>}
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default SideBar;
